// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { OnlineContentFormatType, OnlineContentFiltersForm } from "../schema";
import { serialize_OnlineContentFormatType_internal, deserialize_OnlineContentFormatType_internal } from "./OnlineContentFormatType";

export function serialize_OnlineContentFiltersForm_internal(value: OnlineContentFiltersForm): unknown {
  return ((value: { expertPickFormFilter: boolean | null; formatTypeFilter: OnlineContentFormatType[] }): unknown => {
    return {
      expertPickFormFilter: ((value: boolean | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["expertPickFormFilter"]),
      formatTypeFilter: ((value: OnlineContentFormatType[]): unknown => {
        return value.map((value: OnlineContentFormatType): unknown => {
          return serialize_OnlineContentFormatType_internal(value);
        });
      })(value["formatTypeFilter"]),
    };
  })(value);
}
export function serialize_OnlineContentFiltersForm(obj: OnlineContentFiltersForm): string {
  return renderJsonWithNumbersAsBigint(serialize_OnlineContentFiltersForm_internal(obj));
}
export function deserialize_OnlineContentFiltersForm_internal(value: unknown): ParserResult<OnlineContentFiltersForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    expertPickFormFilter: boolean | null;
    formatTypeFilter: OnlineContentFormatType[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/OnlineContentFiltersForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/OnlineContentFiltersForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "expertPickFormFilter")) {
      return { success: false, reason: `[#/components/schemas/OnlineContentFiltersForm/expertPickFormFilter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'expertPickFormFilter'.` };
    }
    const parsed_expertPickFormFilter = ((): ParserResult<boolean | null> => {
      return ((value: unknown): ParserResult<boolean | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/OnlineContentFiltersForm/expertPickFormFilter]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["expertPickFormFilter"]);
    })();
    if (!parsed_expertPickFormFilter.success) {
      return { success: false, reason: parsed_expertPickFormFilter.reason };
    }
    if (!hasProp(value, "formatTypeFilter")) {
      return { success: false, reason: `[#/components/schemas/OnlineContentFiltersForm/formatTypeFilter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'formatTypeFilter'.` };
    }
    const parsed_formatTypeFilter = ((): ParserResult<OnlineContentFormatType[]> => {
      return ((value: unknown): ParserResult<OnlineContentFormatType[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/OnlineContentFiltersForm/formatTypeFilter]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<OnlineContentFormatType> => {
          return deserialize_OnlineContentFormatType_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/OnlineContentFiltersForm/formatTypeFilter]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["formatTypeFilter"]);
    })();
    if (!parsed_formatTypeFilter.success) {
      return { success: false, reason: parsed_formatTypeFilter.reason };
    }
    return { success: true, value: { expertPickFormFilter: parsed_expertPickFormFilter.value, formatTypeFilter: parsed_formatTypeFilter.value } };
  })(value);
}
export function deserialize_OnlineContentFiltersForm(str: string): ParserResult<OnlineContentFiltersForm> {
  return deserialize_OnlineContentFiltersForm_internal(parseJsonWithNumbersAsBigint(str));
}
